import { AddonCategory } from './AddonCategory'

type TInputType = 'radio' | 'checkbox' | 'amount'

type TOptions = Pick<
  PropsOf<typeof AddonCategory>,
  'maxIndividualCount' | 'minTotalCount' | 'maxTotalCount'
>

/**
 * @param maxTotalCount maximum number of selected addons
 * @param maxIndividualCount maximum amount of each individual addon
 * @returns input type string
 */
export const getInputType = ({
  maxTotalCount,
  maxIndividualCount,
}: Pick<TOptions, 'maxTotalCount' | 'maxIndividualCount'>): TInputType => {
  if (maxTotalCount === 1) {
    return 'radio'
  }

  if (maxIndividualCount === 1) {
    return 'checkbox'
  }

  return 'amount'
}

/**
 * @param minTotalCount minimum number of selected addons
 * @param maxTotalCount maximum number of selected addons
 * @returns message type string & count as an array (min, max or both)
 */
export const getMessageParameters = ({
  minTotalCount,
  maxTotalCount,
}: Pick<TOptions, 'minTotalCount' | 'maxTotalCount'>) => {
  if (!minTotalCount) {
    return maxTotalCount
      ? {
          messageType: 'max' as const,
          count: undefined,
          minCount: undefined,
          maxCount: maxTotalCount,
        }
      : {
          messageType: 'none' as const,
          count: undefined,
          minCount: undefined,
          maxCount: undefined,
        }
  }

  if (!maxTotalCount) {
    return {
      messageType: 'min' as const,
      count: undefined,
      minCount: minTotalCount,
      maxCount: undefined,
    }
  }

  if (maxTotalCount === minTotalCount) {
    return {
      messageType: 'only' as const,
      count: maxTotalCount,
      minCount: undefined,
      maxCount: undefined,
    }
  }

  return {
    messageType: 'minmax' as const,
    count: undefined,
    minCount: minTotalCount,
    maxCount: maxTotalCount,
  }
}
